import React from 'react';
import {Container, DivLinha} from './styles';
import imgWhats from '../../assets/imagens/whats.png';

import { 
  Grid,
  Section,
  CardBody,
  NavItem,
  Nav,
  CardFooter
} from 'uikit-react';
import imgLogo from '../../assets/imagens/logo_de_grao_em_pao_branco.png';

export function Footer(){ 

  return(
      <Container id="footer">        
        <CardFooter  className="uk-section-small uk-section-secondary  uk-text-small">
          <CardBody className="uk-flex uk-flex-center uk-flex-middle container-footer-texto">

              <Section>
                <img className='logo-footer' src={imgLogo} alt='logo' style={{maxWidth: '150px'}}/>
              </Section>
            
          </CardBody>
          {/* <CardFooter> */}
            <DivLinha />
            <small className="uk-text-center uk-text uk-text-small uk-padding-small">&copy;Copyright ©2025 Fundação Bunge.</small>
          {/* </CardFooter>           */}
         
        </CardFooter>
            
      </Container>       
  )
}
 